import { Modal, Button, Form, InputGroup } from "react-bootstrap";
// @ts-ignore
import ReactSlider from "react-slider";
import "../../../scss/orders.scss";

interface FilterModalProps {
  show: boolean;
  onHide: () => void;
  filterValues: {
    selectedStatuses: string[];
    fromDate: string;
    toDate: string;
    minTotal: string;
    maxTotal: string;
  };
  setFilterValues: (vals: any) => void;
  onSearch: (filters: {
    status: string[];
    fromDate: string;
    toDate: string;
    minTotal: number;
    maxTotal: number;
  }) => void;
  onReset: () => void;
}

const orderStatusOptions = [
  // { label: "All", value: "All" },
  // { label: "Intent", value: "Intent" },
  { label: "Pending", value: "Processing" },
  { label: "Cancelled", value: "Cancelled" },
  //Returned
  //Expired
  { label: "Delivered", value: "Delivered" },
  { label: "Successful", value: "Successful" },
  { label: "Ready for Pickup", value: "ReadyForPickup" },
  { label: "Failed", value: "Failed" },
  { label: "Delivery Started", value: "DeliveryStarted" },
  { label: "Delivery Failed", value: "DeliveryFailed" },
  { label: "Payment Failed", value: "PaymentFailed" },
  { label: "Pending Capture", value: "SuccessfulPendingCapture" },
];

const FilterModal = ({
  show,
  onHide,
  filterValues,
  setFilterValues,
  onSearch,
  onReset,
}: FilterModalProps) => {
  const parsedMin = parseFloat(filterValues.minTotal);
  const parsedMax = parseFloat(filterValues.maxTotal);

  const toggleStatus = (statusValue: string) => {
    setFilterValues({
      ...filterValues,
      selectedStatuses: filterValues.selectedStatuses.includes(statusValue)
        ? filterValues.selectedStatuses.filter((s) => s !== statusValue)
        : [...filterValues.selectedStatuses, statusValue],
    });
  };

  const handleSliderChange = ([min, max]: number[]) => {
    setFilterValues({
      ...filterValues,
      minTotal: String(min),
      maxTotal: String(max),
    });
  };

  const handleSearch = () => {
    onSearch({
      status: filterValues.selectedStatuses,
      fromDate: filterValues.fromDate,
      toDate: filterValues.toDate,
      minTotal: isNaN(parsedMin) ? 0 : parsedMin,
      maxTotal: isNaN(parsedMax) ? 1000 : parsedMax,
    });
  };

  return (
    <Modal show={show} onHide={onHide} centered className="order-filter-modal">
      <Modal.Header closeButton>
        <Modal.Title>More Filter</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="subtitle">Filter orders with more option.</p>

        {/* Order status */}
        <div className="form-group">
          <label className="form-label">Order status</label>
          <div className="status-checkboxes">
            {orderStatusOptions.map((status) => (
              <Form.Check
                key={status.value}
                type="checkbox"
                label={status.label}
                checked={filterValues.selectedStatuses.includes(status.value)}
                onChange={() => toggleStatus(status.value)}
                className="me-3"
              />
            ))}
          </div>
        </div>

        {/* Order date */}
        <div className="form-group mt-3 ">
          <label className="form-label">Order date</label>
          <div className="d-flex gap-3 align-items-center flex-wrap order-date-range">
            <div className="d-flex align-items-center gap-1">
              <span className="date-label">From:</span>
              <Form.Control
                type="date"
                value={filterValues.fromDate}
                onChange={(e) =>
                  setFilterValues({ ...filterValues, fromDate: e.target.value })
                }
                className="date-input"
              />
            </div>
            <div className="d-flex align-items-center gap-1">
              <span className="date-label">To:</span>
              <Form.Control
                type="date"
                value={filterValues.toDate}
                onChange={(e) =>
                  setFilterValues({ ...filterValues, toDate: e.target.value })
                }
                className="date-input"
              />
            </div>
          </div>
        </div>

        {/* Subtotal */}
        <div className="form-group mt-4">
          <label className="form-label">Subtotal</label>
          <div className="d-flex justify-content-between mb-2">
            <InputGroup style={{ width: 120 }}>
              <InputGroup.Text>$</InputGroup.Text>
              <Form.Control
                size="sm"
                type="text"
                value={filterValues.minTotal}
                onChange={(e) =>
                  setFilterValues({ ...filterValues, minTotal: e.target.value })
                }
                placeholder="Min"
              />
            </InputGroup>
            <InputGroup style={{ width: 120 }}>
              <InputGroup.Text>$</InputGroup.Text>
              <Form.Control
                size="sm"
                type="text"
                value={filterValues.maxTotal}
                onChange={(e) =>
                  setFilterValues({ ...filterValues, maxTotal: e.target.value })
                }
                placeholder="Max"
              />
            </InputGroup>
          </div>

          <ReactSlider
            className="price-slider"
            thumbClassName="price-thumb"
            renderTrack={(props: any, state: any) => {
              const trackClass =
                state.index === 1
                  ? "price-track price-track-active"
                  : "price-track";
              return <div {...props} className={trackClass} />;
            }}
            value={[
              isNaN(parsedMin) ? 0 : parsedMin,
              isNaN(parsedMax) ? 1000 : parsedMax,
            ]}
            min={0}
            max={1000}
            step={0.01}
            onChange={handleSliderChange}
          />
        </div>
      </Modal.Body>
      <Modal.Footer className="justify-content-center">
        <Button className="filter-btn" onClick={handleSearch}>
          Filter Orders
        </Button>
        <Button variant="secondary" onClick={onReset}>
          Reset
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default FilterModal;
